
import TomSelect from "tom-select/base";
export default class CustomSelect{
    
    constructor(element) {
        this._wrapper = element;
        this._select = this._wrapper.querySelector('select');
        
        this.init();
        this.bindEvents();
    }
    
    init(){
        this.ts = new TomSelect(this._select, { 
            // controlInput: null
            render:{
                item: function(data, escape) {
                    return '<div>'+ (this.items.length > 0 ? ', ' : '') + escape(data.text) + '</div>';
                },
            }
        });
        this._tags = app.createElement('<div class="js-custom-select-tags"></div>');
        this._tags = this._tags[0]
        this.ts.wrapper.insertAdjacentElement('afterend',this._tags);
    }
    
    bindEvents(){
        this.ts.on('change', this.updateTags.bind(this));
    }
    
    
    updateTags(){
        this._tags.innerHTML = '';
        let selectedOptions = Array.from(this._select.options).filter(option => option.selected);
        selectedOptions.forEach((el,i) => {
            let _tag = app.createElement('<div class="js-custom-select-tag">'+el.innerText+'<i class="fa-regular fa-xmark"></i></div>');
            _tag = _tag[0];
            this._tags.appendChild(_tag);
            _tag.addEventListener('click', () => {
                this.ts.removeItem(el.value);
            });
        });
    }
    
}